import { render, staticRenderFns } from "./mChat.vue?vue&type=template&id=3f3ec642&scoped=true"
import script from "./mChat.vue?vue&type=script&lang=js"
export * from "./mChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3ec642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f3ec642')) {
      api.createRecord('3f3ec642', component.options)
    } else {
      api.reload('3f3ec642', component.options)
    }
    module.hot.accept("./mChat.vue?vue&type=template&id=3f3ec642&scoped=true", function () {
      api.rerender('3f3ec642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autism/mChat/mChat/mChat.vue"
export default component.exports